import { useTalent } from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";
import NEWSkillFormButton from "../components/NEWSkillFormButton";


const TalentProfileRolesSkills = () => {
    const { talent } = useTalent();

    return (
        <ProfileContainer>
            <div id="roles" className="pb-12">
                <h4 className="text-bold font-xl pb-6">Roles</h4>

                <div className="flex gap-4 flex-wrap">
                    {talent.talent_disciplines?.map(discipline => {
                        return (
                            <NEWSkillFormButton
                                key={discipline.id}
                                className="has-skill"
                                skill={discipline}
                                selected
                            />
                        )
                    })}
                </div>
            </div>


            <div id="skills" className="pb-12">
                <h4 className="text-bold font-xl pb-6">Skills</h4>

                <div className="flex gap-4 flex-wrap">
                    {talent.skills?.map(skill => {
                        return (
                            <NEWSkillFormButton
                                key={skill.id}
                                className="has-skill"
                                disabled
                                skill={skill}
                                selected
                            />
                        )
                    })}
                </div>
            </div>

            <div id="industry-expertise" className="">
                <h4 className="text-bold font-xl pb-6">Industry Expertise</h4>

                <div className="flex gap-4 flex-wrap">
                    {talent.industries_worked?.map(industry => {
                        return (
                            <NEWSkillFormButton
                                key={industry.id}
                                className="has-skill"
                                disabled
                                skill={industry}
                                selected
                            />
                        )
                    })}
                </div>

                {/* <div className="flex gap-4 flex-wrap job-match-scores-container">
                    <div className="discipline-skills-container skill-importance-container">

                        {talent.industries_worked?.map(industry => {
                            return (
                                <SkillFormButton
                                    key={industry.id}
                                    className="has-skill"
                                    // valuePropName={(toggleScore && this.state[`${TB.toLower(title)}Toggled`]) ? toggleScore : "self_score"}
                                    disabled
                                    // scoringOptions={scoring_options}
                                    skill={industry}
                                    selected
                                />
                            )
                        })}
                    </div>
                </div> */}
            </div>
        </ProfileContainer>
    )
}

export default TalentProfileRolesSkills;